var React = require('react');

function Dropdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.00011 5.93933L8.00011 8.93933L11.0001 5.93933L12.0608 6.99999L8.00011 11.0607L3.93945 6.99999L5.00011 5.93933Z","fill":"#181818"}));
}

Dropdown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Dropdown;

Dropdown.default = Dropdown;
